import React, { FC } from 'react';
import { SbBlokData } from '@storyblok/react';
import classnames from 'classnames';

import { ListItemIcon, Ul } from '@savebetter/components';

import { useBankProducts } from '../context/BankProductsContext';
import { useDatasources } from '../context/DataSourceContext';
import { useCustomVar } from '../hooks/useCustomVar';

interface ListItem extends SbBlokData {
  text: string;
}

interface IntroductionListProps {
  introductionList: ListItem[];
  isTextWhite: boolean;
}

interface IntroductionItemProps {
  itemText: string;
  isTextWhite: boolean;
}

const introListClasses = (isWhite: boolean): string => classnames({ 'text-white': isWhite });

const IntroductionItem: FC<IntroductionItemProps> = ({ itemText, isTextWhite }) => {
  const { contextProducts } = useBankProducts();
  const { contextDatasources } = useDatasources();
  const { resolvedText, textOpacityClass } = useCustomVar(itemText, contextProducts, contextDatasources);

  return (
    <ListItemIcon
      text={resolvedText}
      className={`${textOpacityClass} transition-opacity ${introListClasses(isTextWhite)}`}
      kind="responsive"
      icon="CheckCircleOutlineOutlinedIcon"
    />
  );
};

const IntroductionList: FC<IntroductionListProps> = ({ introductionList, isTextWhite }) => (
  <div className={classnames('lg:mt-8 md:mt-0 sm:mt-8 md:w-2/3')}>
    <Ul style={{ paddingLeft: 0 }}>
      {introductionList.map(({ _uid, text }) => (
        <IntroductionItem key={_uid} itemText={text} isTextWhite={isTextWhite} />
      ))}
    </Ul>
  </div>
);

export default IntroductionList;
